import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { Color, ColorCollection, ColorGroup } from 'ri-api-client';

@Injectable()
export class ColorsService {

  public colors: Color.Color[] = [];
  private noColor: Color.Color = {
    colorCode: '#222222',
    colorGroupId: 0,
    id: 0,
    name: '',
    outlineColorCode: '#111111',
    title: ''
  };

  private groupIndexMap; // dictionary for tracking color indexses in color groups

  constructor(
    private apiService: ApiService
  ) {
    this.apiService.init();

    this.groupIndexMap = new Map();
  }

  get(): Observable<ColorCollection.ColorCollection> {
    return this.apiService.client.colors.GET()
      .map((res) => {
        const response = this.apiService.handleResponse(res);
        this.colors = response.results;
        return response;
      });
  }

  getByTitle(title: string): Color.Color {
    if (!this.colors.length) {
      return this.noColor;
    }
    return this.colors.find(value => value.title === title) || this.getByGroup();
  }

  getByGroup(group: number = 1): Color.Color {
    let groupIndex = 0;   // color group index
    let totalInGroup = 0; // total colors in group

    if (!this.colors.length) {
      return this.noColor;
    }

    // calculate color index in color group (index in current group)
    if (this.groupIndexMap.has(group)) {
      groupIndex = this.groupIndexMap.get(group);
      groupIndex++;
      this.groupIndexMap.set(group, groupIndex);
    } else {
      groupIndex = 0;
      this.groupIndexMap.set(group, groupIndex);
    }

    // total colors in group
    totalInGroup = this.colors.filter(value2 => value2.colorGroupId === group).length;

    return this.colors.filter(value => value.colorGroupId === group).find((value, key, array) => key === (groupIndex) % (totalInGroup));
  }

  getByColorId(id: number): Color.Color {
    if (!this.colors.length) {
      return this.noColor;
    }
    return this.colors.find(value => value.id === id) || this.getByGroup();
  }

  getById(id: number): Observable<any[]> {
    return this.apiService.client.colors.colorId(id.toString()).GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  groups(): Observable<any[]> {
    return this.apiService.client.colors.groups.GET()
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  update(color: Color.Color): Observable<any[]> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.apiService.client.colors.colorId(color.id.toString()).PATCH(color, options)
      .map((res) => {
        return this.apiService.handleResponse(res);
      });
  }

  cleanGroupIndexes() {
    this.groupIndexMap.clear();
  }

}



// WEBPACK FOOTER //
// ./src/app/core/api/colors.service.ts